import React from "react";
import Svg, { Path, G, Defs, ClipPath } from "react-native-svg";

function Address(props) {
  return (
    <Svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M21.5845 17.4215L14.5194 4.43419C13.3843 2.52321 10.6172 2.52067 9.48058 4.43419L2.41589 17.4215C1.2555 19.3742 2.66039 21.847 4.93472 21.847H19.065C21.3375 21.847 22.7448 19.3762 21.5845 17.4215ZM12 19.5032C11.354 19.5032 10.8281 18.9774 10.8281 18.3313C10.8281 17.6853 11.354 17.1595 12 17.1595C12.646 17.1595 13.1719 17.6853 13.1719 18.3313C13.1719 18.9774 12.646 19.5032 12 19.5032ZM13.1719 14.8157C13.1719 15.4617 12.646 15.9876 12 15.9876C11.354 15.9876 10.8281 15.4617 10.8281 14.8157V8.95634C10.8281 8.31032 11.354 7.78446 12 7.78446C12.646 7.78446 13.1719 8.31032 13.1719 8.95634V14.8157Z"
        fill="#F25700"
      />
    </Svg>
  );
}

export default Address;
